module.exports = __webpack_public_path__ + "static/img/IoT-Let.png";